import React from 'react';
import { MessageSquare, Phone, Star } from 'lucide-react';
import { site } from '../data/site';
const bullets = ['Free Estimates', 'Quality Work', 'Friendly Service'];
export function Hero() {
  return <section id="top" className="w-full bg-[#0B1B3A] text-white" data-id="element-29" data-mp="9k0fha3kwjqp">
      <div className="mx-auto grid w-full max-w-7xl items-center gap-10 px-5 py-14 lg:grid-cols-[1.15fr_1fr] lg:gap-8 lg:px-10 lg:py-20" data-id="element-30" data-mp="4lqiqv27hb2z">
        <div data-id="element-31" data-mp="128fqzmni4jxa">
          <p className="inline-flex items-center gap-2 bg-[#FACC15] px-4 py-2 font-heading text-xs font-black uppercase tracking-[0.2em] text-[#0B1B3A]" data-id="element-32" data-mp="12862k3i3uktp">
            <Star className="h-3.5 w-3.5" aria-hidden="true" data-id="element-33" data-mp="sb1ajn1kvv4z" />
            Locally owned · {site.area}
          </p>

          <h1 className="mt-6 font-heading text-5xl font-black uppercase leading-[0.9] tracking-tight sm:text-6xl lg:text-7xl" data-id="element-34" data-mp="nczs94bz7zuk">
            Paint that
            <br data-id="element-35" data-mp="3czfms3kkof85" />
            <span className="text-[#FACC15]" data-id="element-36" data-mp="382fedm0930dv">looks sharp</span>
            <br data-id="element-37" data-mp="380w0g222h1f9" />
            and lasts.
          </h1>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/75" data-id="element-38" data-mp="3j7zgtn69y0is">
            Interior and exterior painting done by hand, done clean, done on
            schedule. Call or text {site.contactName} and get a free estimate
            today.
          </p>

          <ul className="mt-8 flex flex-wrap gap-x-6 gap-y-3" data-id="element-39" data-mp="39cpc2rohrf1b">
            {bullets.map(item => <li key={item} className="font-heading text-sm font-black uppercase tracking-widest text-white" data-id="element-40" data-mp="3eb91x367hayy">
                <span className="mr-2 text-[#FACC15]" data-id="element-41" data-mp="359j85qoupzy0">—</span>
                {item}
              </li>)}
          </ul>

          <div className="mt-10 flex flex-col gap-3 sm:flex-row" data-id="element-42" data-mp="2qhqwboo9n411">
            <a href={site.phoneHref} className="flex items-center justify-center gap-3 bg-[#FACC15] px-8 py-5 font-heading text-lg font-black uppercase tracking-widest text-[#0B1B3A] hover:bg-[#eab308]" data-id="element-43" data-mp="2vjq0h0rty4z1">
              <Phone className="h-5 w-5" aria-hidden="true" data-id="element-44" data-mp="s21gq7e3o5xv" />
              {site.phone}
            </a>
            <a href={site.smsHref} className="flex items-center justify-center gap-3 border-4 border-white px-8 py-5 font-heading text-lg font-black uppercase tracking-widest text-white hover:bg-white hover:text-[#0B1B3A]" data-id="element-45" data-mp="nbbe31x26h6v">
              <MessageSquare className="h-5 w-5" aria-hidden="true" data-id="element-46" data-mp="deyj80ps1xaj" />
              Text for a quote
            </a>
          </div>
        </div>

        <div className="relative flex justify-center" data-id="element-47" data-mp="161axp9a4r42w">
          <div aria-hidden="true" className="absolute inset-x-6 bottom-6 top-10 bg-[#FACC15]" data-id="element-48" data-mp="162lyd08a3vps" />
          <img src={site.logo} alt="Rangel's Painting mascot: a painter with a ladder, roller and paint can" className="relative w-full max-w-md object-contain drop-shadow-2xl" data-id="element-49" data-mp="x14kzpm9a84s" />
        </div>
      </div>
    </section>;
}